import {useEffect, useState} from "react";
import {DataTableSortStatus} from "mantine-datatable";
import {sortBy} from "lodash";
import {DataTableProps} from "./DataTable";

export type UseDataTableSorterProps<T> = {
  records: T[]
  sortStatus: DataTableSortStatus,
  sortConfig?: DataTableSorterConfig<T>
}

export type UseDataTableSorterResult<T> = Pick<DataTableProps<T>, 'sortStatus' | 'onSortStatusChange'> & {
  sortedRecords: T[]
  sortConfig?: DataTableSorterConfig<T>
}

export type DataTableSorterConfig<T> = {
  [key: string]: {
    sort?: (a: T, b: T) => number
    sortAll?: (records: T[], columnAccessor: string) => T[]
  }
}

export function useDataTableSorter<T>(props: UseDataTableSorterProps<T>): UseDataTableSorterResult<T> {
  const {records, sortConfig} = props;

  const [sortStatus, setSortStatus] = useState<DataTableSortStatus>({columnAccessor: 'dttm', direction: 'asc'});
  const [sortedRecords, setSortedRecords] = useState<T[]>(sortBy(records, 'dttm'));

  useEffect(() => {
    console.log("sorting changed")
    let sorted = false
    let data: T[] = []
    if (sortConfig && sortStatus.columnAccessor in sortConfig) {
      const config = sortConfig[sortStatus.columnAccessor]
      if (config.sort) {
        data = records.sort(config.sort)
        sorted = true
      } else if (config.sortAll) {
        data = config.sortAll(records, sortStatus.columnAccessor)
        sorted = true
      }
    }

    if (!sorted) {
      data = sortBy(records, sortStatus.columnAccessor) as T[];
    }

    setSortedRecords(sortStatus.direction === 'desc' ? data.reverse() : data);
  }, [records, sortStatus, sortConfig]);

  return {
    sortedRecords: sortedRecords,
    sortStatus: sortStatus,
    onSortStatusChange: setSortStatus,
    sortConfig: sortConfig,
  };
}
